exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-link[data-v-8192baee] {\n  color: #111;\n}\n.router-link-active[data-v-8192baee] {\n  font-weight: bold;\n  color: #3498DB;\n}\n", ""]);

// exports
